import none from "./none.js";

export default function(series) {
  return none(series).reverse();
}



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/d3-shape/src/order/reverse.js
// module id = Eewl
// module chunks = 0